import { pageMenu } from "../routes/menu";

export function bgHandler(path) {
  document.getElementById("appContainer").removeAttribute("class");

  switch (path) {
    case pageMenu.homePage.path:
      document
        .getElementById("appContainer")
        .setAttribute("class", "homeContainer");
      break;

    case pageMenu.portfolioPage.path:
      document
        .getElementById("appContainer")
        .setAttribute("class", "portfolioContainer");
      break;

    case pageMenu.aboutPage.path:
      document
        .getElementById("appContainer")
        .setAttribute("class", "aboutContainer");
      break;

    case pageMenu.contactPage.path:
      document
        .getElementById("appContainer")
        .setAttribute("class", "contactContainer");
      break;

    case pageMenu.blogPage.path:
      document
        .getElementById("appContainer")
        .setAttribute("class", "blogContainer");
      break;

    default:
      document
        .getElementById("appContainer")
        .setAttribute("class", "defaultContainer");
      break;
  }
}
